<app-oee-modal
    title="Resume Job"
    subtitle="Return this job to running status"
    [contextName]="data.batchNumber || 'Job'"
    icon="replay"
    [useMaterialIcon]="true"
    iconColor="green"
    tint="green"
    size="sm">

    <!-- Modal Content -->
    <ng-container modal-content>
        <div class="info-box">
            <i class="fa fa-info-circle"></i>
            <div class="info-content">
                <strong>What happens when you resume:</strong>
                <ul>
                    <li>The end date will be cleared</li>
                    <li>OEE metrics will be recalculated</li>
                    <li>Parts data (good parts, reject parts) will be preserved</li>
                    <li>The batch will appear as a running job again</li>
                </ul>
            </div>
        </div>

        @if (data.batchNumber || data.equipmentName) {
            <div class="batch-info">
                @if (data.batchNumber) {
                    <div class="info-row">
                        <span class="label">Job:</span>
                        <span class="value">{{ data.batchNumber }}</span>
                    </div>
                }
                @if (data.equipmentName) {
                    <div class="info-row">
                        <span class="label">Equipment:</span>
                        <span class="value">{{ data.equipmentName }}</span>
                    </div>
                }
            </div>
        }
    </ng-container>

    <!-- Modal Actions -->
    <ng-container modal-actions>
        <button mat-button (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="primary" class="btn-success" (click)="onConfirm()">
            <mat-icon>replay</mat-icon>
            Resume Job
        </button>
    </ng-container>

</app-oee-modal>
